import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth
export const login = (email, password) => 
  axios.post(`${API}/auth/login`, { email, password });

export const getMe = () => 
  axios.get(`${API}/auth/me`);

// Bookings
export const getBookings = (date) => 
  axios.get(`${API}/bookings`, { params: { date } });

export const getBooking = (hubhusBookingId) => 
  axios.get(`${API}/booking/${hubhusBookingId}`);

export const getBookingCoaching = (hubhusBookingId) => 
  axios.get(`${API}/booking/${hubhusBookingId}/coaching`);

export const generateCoaching = (hubhusBookingId) => 
  axios.post(`${API}/booking/${hubhusBookingId}/coaching/generate`);

export const submitFeedback = (hubhusBookingId, data) => 
  axios.post(`${API}/booking/${hubhusBookingId}/feedback`, data);

// Survey (public)
export const getSurvey = (token) => 
  axios.get(`${API}/survey/${token}`);

export const submitSurvey = (token, answers) => 
  axios.post(`${API}/survey/${token}/submit`, { answers });

// Invitation (public)
export const validateInvitation = (token) => 
  axios.get(`${API}/invite/${token}`);

export const setPasswordFromInvite = (token, data) => 
  axios.post(`${API}/invite/${token}/set-password`, data);

// Forgot password (public)
export const requestPasswordReset = (email) => 
  axios.post(`${API}/auth/forgot-password`, { email });

// Admin - Users
export const getUsers = (params) => 
  axios.get(`${API}/admin/users`, { params });

export const getUser = (userId) => 
  axios.get(`${API}/admin/users/${userId}`);

export const createUser = (data) => 
  axios.post(`${API}/admin/users`, data);

export const updateUser = (userId, data) => 
  axios.put(`${API}/admin/users/${userId}`, data);

export const toggleUserActive = (userId) => 
  axios.put(`${API}/admin/users/${userId}/activate`);

export const deleteUser = (userId) => 
  axios.delete(`${API}/admin/users/${userId}`);

export const resendInvitation = (userId) => 
  axios.post(`${API}/admin/users/${userId}/send-invite`);

export const sendPasswordReset = (userId) => 
  axios.post(`${API}/admin/users/${userId}/reset-password`);

export const setUserPassword = (userId, password) => 
  axios.put(`${API}/admin/users/${userId}/set-password`, { password });

export const updateUserDisc = (userId, data) => 
  axios.put(`${API}/admin/users/${userId}/disc`, data);

export const uploadDiscPdf = (userId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/admin/users/${userId}/disc-pdf`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const getDiscPdfUrl = (userId) => 
  `${API}/admin/users/${userId}/disc-pdf`;

export const deleteDiscPdf = (userId) => 
  axios.delete(`${API}/admin/users/${userId}/disc-pdf`);

// Admin - Hubhus
export const testHubhusConnection = (config) => 
  axios.post(`${API}/admin/hubhus/test`, config);

export const triggerHubhusSync = () => 
  axios.post(`${API}/admin/hubhus/sync-now`);

export const getHubhusConfig = () => 
  axios.get(`${API}/admin/hubhus/config`);

export const getSyncLogs = (limit = 50, type) => 
  axios.get(`${API}/admin/sync-logs`, { params: { limit, type } });

// Admin - Stats
export const getStats = () => 
  axios.get(`${API}/admin/stats`);

// Admin - Settings
export const getAdminSettings = () =>
  axios.get(`${API}/admin/settings`);

export const updateAdminSettings = (autoSendSurveyEmails) =>
  axios.put(`${API}/admin/settings`, null, { params: { auto_send_survey_emails: autoSendSurveyEmails } });

// Admin - Booking management
export const assignConsultantToBooking = (hubhusBookingId, consultantUserId) =>
  axios.put(`${API}/admin/booking/${hubhusBookingId}/assign`, { consultant_user_id: consultantUserId });

export const createTestSurvey = (hubhusBookingId, sendEmail = false) =>
  axios.post(`${API}/admin/booking/${hubhusBookingId}/create-test-survey`, null, { params: { send_email: sendEmail } });

// Push
export const getVapidPublicKey = () => 
  axios.get(`${API}/push/vapid-public-key`);

export const registerPushToken = (data) => 
  axios.post(`${API}/push/register`, data);

// Admin - User Sync
export const syncUsersFromHubhus = () =>
  axios.post(`${API}/admin/users/sync-from-hubhus`);

// Admin - Email Flow
export const getEmailFlowSettings = () =>
  axios.get(`${API}/admin/email-flow/settings`);

export const updateEmailFlowSettings = (settings) =>
  axios.put(`${API}/admin/email-flow/settings`, settings);

export const getEmailFlowStats = () =>
  axios.get(`${API}/admin/email-flow/stats`);

export const getEmailFlows = (status) =>
  axios.get(`${API}/admin/email-flow/flows`, { params: { status } });

export const sendTestEmail = (emailId, testEmail) =>
  axios.post(`${API}/admin/email-flow/test-email`, { email_id: emailId, test_email: testEmail });

export const startTestEmailFlow = () =>
  axios.post(`${API}/admin/email-flow/start-test`);

export const processPendingEmails = () =>
  axios.post(`${API}/admin/email-flow/process-pending`);

export const stopEmailFlow = (bookingId) =>
  axios.post(`${API}/admin/email-flow/stop/${bookingId}`);

export const markFlowConverted = (bookingId) =>
  axios.post(`${API}/admin/email-flow/mark-converted/${bookingId}`);

// Admin - System Maintenance
export const fixConsultantIds = () =>
  axios.post(`${API}/admin/bookings/fix-consultant-ids`);

export const backfillMissingSurveys = () =>
  axios.post(`${API}/admin/surveys/backfill-missing`);

// Admin - Survey Log
export const getSurveySentLog = (status = 'all', limit = 100) =>
  axios.get(`${API}/admin/surveys/sent-log`, { params: { status, limit } });
